import { useMutation } from '@tanstack/react-query';
import { POST, POST_LINE_MESSAGE_TEMPLATE_INSERT } from '../../../services';
import { openAlert } from '../../../components/alert/useAlert';

export const useInsertLineMessageTemplate = ({ onSuccessCallBack } = {}) =>
  useMutation({
    mutationFn: async (values) => {
      const response = await POST(POST_LINE_MESSAGE_TEMPLATE_INSERT(), values);
      if (response?.success === false) throw new Error(response.message);
      return response?.result;
    },
    onSuccess: () => {
      openAlert({ model: 'message', type: 'success', message: 'เพิ่ม template สำเร็จ' });
      onSuccessCallBack?.();
    },
  });
